import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=4f14a3b4&scoped=true"
import script from "./NewsBlock.vue?vue&type=script&lang=js"
export * from "./NewsBlock.vue?vue&type=script&lang=js"
import style0 from "./NewsBlock.vue?vue&type=style&index=0&id=4f14a3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f14a3b4",
  null
  
)

export default component.exports